import { useParams } from 'react-router-dom';
import { useOrganization } from '@clerk/clerk-react';

/**
 * Hook to get the organization slug from the URL
 * Returns the slug from URL params and the current active organization
 */
export function useOrgSlug() {
    const { orgSlug } = useParams<{ orgSlug: string }>();
    const { organization, isLoaded } = useOrganization();

    return {
        urlSlug: orgSlug,
        activeOrgSlug: organization?.slug,
        activeOrgId: organization?.id,
        organization,
        isLoaded,
        isValidSlug: isLoaded && orgSlug === organization?.slug,
    };
}

